import submitAvatar from 'assets/img/default-avatar.png'
import logo from 'assets/img/wic/aplss.png'
import AuthContext from 'context/auth/authContext'
import PerfectScrollbar from 'perfect-scrollbar'
import PropTypes from 'prop-types'
import React, { useEffect, useRef, useState, useContext } from 'react'
import { NavLink, useLocation } from 'react-router-dom'
import { Collapse, Nav } from 'reactstrap'
import { useOktaAuth } from '@okta/okta-react'

let ps

const Sidebar = ({ bgColor, activeColor, routes }) => {
  const location = useLocation()
  // this verifies if any of the collapses should be default opened on a rerender of this component
  // for example, on the refresh of the page,
  // while on the src/views/forms/RegularForms.jsx - route /admin/regular-forms
  const getCollapseInitialState = currentRoutes => {
    for (let i = 0; i < currentRoutes.length; i += 1) {
      if (
        currentRoutes[i].collapse &&
        getCollapseInitialState(currentRoutes[i].views)
      ) {
        return true
      }
      if (window.location.pathname.indexOf(currentRoutes[i].path) !== -1) {
        return true
      }
    }
    return false
  }

  // this creates the intial state of this component based on the collapse routes
  // that it gets through this.props.routes
  const getCollapseStates = currentRoutes => {
    let initialState = {}
    currentRoutes.map(route => {
      if (route.collapse) {
        initialState = {
          [route.state]: getCollapseInitialState(route.views),
          ...getCollapseStates(route.views),
          ...initialState,
        }
      }
      return null
    })
    return initialState
  }

  const [collapseState, setCollapseState] = useState(getCollapseStates(routes))
  const sidebar = useRef()
  const authContext = useContext(AuthContext)

  const { user } = authContext
  const { authState } = useOktaAuth()

  const avatar = submitAvatar

  useEffect(() => {
    // if you are using a Windows Machine, the scrollbars will have a Mac look
    if (navigator.platform.indexOf('Win') > -1) {
      ps = new PerfectScrollbar(sidebar.current, {
        suppressScrollX: true,
        suppressScrollY: false,
      })
    }

    return () => {
      // we need to destroy the false scrollbar when we navigate
      // to a page that doesn't have this component rendered
      if (navigator.platform.indexOf('Win') > -1) {
        ps.destroy()
      }
    }
  }, [])

  // verifies if routeName is the one active (in browser input)
  const activeRoute = routeName =>
    location.pathname.indexOf(routeName) > -1 ? 'active' : ''

  // this function creates the links and collapses that appear in the sidebar (left menu)
  const createLinks = linkRoutes =>
    linkRoutes.map((prop, key) => {
      const {
        redirect,
        state,
        views,
        collapse,
        icon,
        name,
        mini,
        layout,
        path,
        header,
      } = prop
      if (redirect || path === '/my-profile') {
        return null
      }
      if (header) {
        return (
          <li className={''} key={key}>
            <span className="sidebar-header">{name}</span>
          </li>
        )
      }
      if (collapse) {
        const st = {}
        st[state] = !collapseState[state]
        return (
          <li
            className={getCollapseInitialState(views) ? 'active' : ''}
            key={key}
          >
            <a
              href="#pablo"
              data-toggle="collapse"
              aria-expanded={collapseState[state]}
              onClick={e => {
                e.preventDefault()
                setCollapseState(st)
              }}
            >
              {icon !== undefined ? (
                <>
                  <i className={icon} />
                  <p>
                    {name}
                    <b className="caret" />
                  </p>
                </>
              ) : (
                <>
                  <span className="sidebar-mini-icon">
                    <i className={mini} />
                  </span>
                  <span className="sidebar-normal">
                    {name}
                    <b className="caret" />
                  </span>
                </>
              )}
            </a>
            <Collapse isOpen={collapseState[state]}>
              <ul className="nav">{createLinks(views)}</ul>
            </Collapse>
          </li>
        )
      }

      return (
        <li className={activeRoute(layout + path)} key={key}>
          <NavLink to={layout + path} activeClassName="">
            {icon !== undefined ? (
              <>
                <i className={icon} />
                <p>{name}</p>
              </>
            ) : (
              <>
                <span className="sidebar-mini-icon">
                  <i className={mini} />
                </span>
                <span className="sidebar-normal">{name}</span>
              </>
            )}
          </NavLink>
        </li>
      )
    })

  return (
    <div
      className="sidebar"
      data-color={bgColor}
      data-active-color={activeColor}
    >
      <div className="logo">
        <a href="/" className="simple-text logo-mini">
          <div className="logo-img">
            <img src={logo} alt="APLLS Logo" height="66" width="100" />
          </div>
        </a>
        <a href="/" className="simple-text logo-normal">
          <img src={logo} alt="APLSS Logo" height="66" width="100" />
        </a>
      </div>

      <div className="sidebar-wrapper" ref={sidebar}>
        {authState.isAuthenticated ? (
          <div className="user">
            <div className="photo">
              <img src={avatar} alt="Avatar" />
            </div>
            <h5 className="text-success mb-0">
              <small>{`${user?.firstName || ''} ${user?.lastName ||
                ''}`}</small>
            </h5>
          </div>
        ) : (
          ''
        )}
        <Nav>{createLinks(routes)}</Nav>
      </div>
    </div>
  )
}

Sidebar.propTypes = {
  bgColor: PropTypes.string,
  activeColor: PropTypes.string,
  routes: PropTypes.array,
  location: PropTypes.object,
}

export default Sidebar
